import { Link } from 'react-router-dom';
import { useLanguage } from '../../../contexts/useLanguage';
import contactLogo from '../../../assets/readdy/60ff3a18dd5605b1f76c7856e3032bde__dd3962c993.png';

interface NavbarProps {
  scrolled: boolean;
}

export default function Navbar({ scrolled }: NavbarProps) {
  const { language } = useLanguage();

  const content = {
    zh: {
      backToHome: '返回首页'
    },
    en: {
      backToHome: 'Back to Home'
    }
  };

  const t = content[language];

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      scrolled ? 'bg-white shadow-md' : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <Link to="/" className="flex items-center space-x-3 cursor-pointer">
            <img 
              src={contactLogo}
              alt="ComiAI Logo"
              className="h-10 w-auto object-contain"
            />
          </Link>

          <Link
            to="/"
            className="px-6 py-2.5 bg-black text-white text-sm font-medium rounded-full hover:bg-gray-800 transition-all whitespace-nowrap cursor-pointer"
          >
            {t.backToHome}
          </Link>
        </div>
      </div>
    </nav>
  );
}
